import { IBreakEntity } from "sh-models";
import { mutatorAction } from "satcheljs";
import { shiftEditorViewState } from "..";

export default mutatorAction("updateBreaksSmartScheduleShift", function updateBreaksSmartScheduleShift(breaks: IBreakEntity[]) {
    if (shiftEditorViewState().smartScheduleShift) {
        shiftEditorViewState().smartScheduleShift.breaks = breaks;
    }
});